import { ReactComponent as Bell } from "../assets/icons/bell.svg";
import { isNotificationEnabled } from "../integrations/posthog/featureFlags";
import { useApp } from "../services/app-context";
import { useUser } from "../services/user-context";

/**
 * Shared notification bell button: opens the notification modal when notifications
 * are enabled via feature flag, and shows an unseen-indicator dot when applicable.
 * Use anywhere a header notification trigger is needed.
 */
export function NotificationButton() {
  const { setNotificationModal } = useApp();
  const { hasPendingNotifications } = useUser() as { hasPendingNotifications?: { hasUnseenNotifications?: boolean } };

  if (!isNotificationEnabled()) return null;

  return (
    <button
      type="button"
      onClick={() => setNotificationModal(true)}
      className="relative bg-white hover:opacity-80 w-[37px] h-[37px] rounded-full flex items-center justify-center"
    >
      <Bell className="w-[15px] h-[17px] [&_path]:stroke-primary3" />
      {hasPendingNotifications?.hasUnseenNotifications && (
        <div className="bg-primary3 w-3 h-3 border-[1.5px] border-white rounded-full absolute top-0 right-0" />
      )}
    </button>
  );
}
